import { IServerResponse } from "app/interface";

export interface PerformaceTrackerState {
    performanceTrackerList: Array<any> | null;
    performanceTrackerByFieldList: Array<any> | null;
    performanceTrackerById: any;
    savePerformanceTrackerResp: IServerResponse;
    deletePerformanceTrackerResp: IServerResponse
}

export const initialState: PerformaceTrackerState = {
    performanceTrackerList: null,
    performanceTrackerByFieldList: null,
    performanceTrackerById: null,
    savePerformanceTrackerResp: null,
    deletePerformanceTrackerResp: null
}
